import moment from 'moment';
import 'moment/locale/uz';
import 'moment/locale/uz-latn';
import 'moment/locale/ru';

moment.locale('en', { week: { dow: 1, doy: 1 } });
moment.locale('ru', { week: { dow: 1, doy: 1 } });
moment.locale('uz', { week: { dow: 1, doy: 1 } });